<template>
  <a-modal
    v-model="show"
    :footer="null"
    :width="width"
    @cancel="close"
    class="all-my-referral-modal"
    :maskClosable="false"
  >
    <!-- HEADER -->
    <template slot="title">
      <div class="all-my-referral-modal__header">
        <div class="all-my-referral-modal__title">
          <span>
            <font-awesome-icon
              class="ant-icon"
              :icon="['fas', 'user-friends']"
            />
            {{ labels.allReferralModal.title }}
          </span>
        </div>
      </div>
    </template>
    <div class="all-my-referral-modal__content">
      <p class="all-my-referral-modal__subtitle">
        {{ labels.allReferralModal.subtitle }}
      </p>
      <StandardTable
        v-if="show"
        ref="standardTable"
        :fetchService="getAllMyReferrals"
        :columns="columns"
        :locale="locale"
        :handleShowTotal="handleShowTotal"
      />
    </div>
  </a-modal>
</template>

<script>
import EventBus, { ListEvents } from "@/event";
import labels from "@/utils/labels";
import { mapActions, mapState } from "vuex";
import accounting from "accounting";
import StandardTable from "../core/table/StandardTable.vue";
import { DATE_FORMAT } from "../../utils/utils";
export default {
  name: "AllMyReferralModal",
  components: { StandardTable },
  data() {
    return {
      show: false,
      labels: { ...labels.referral, appName: labels.appName },
      loading: false,
      bonus: null,
      applyAmount: null,
      rules: "",
    };
  },
  async created() {
    EventBus.$on(ListEvents.open_all_my_referrals_modal, this.open);
    EventBus.$on(ListEvents.close_all_my_referrals_modal, this.close);
  },
  beforeDestroy() {
    EventBus.$off(ListEvents.open_all_my_referrals_modal);
    EventBus.$off(ListEvents.close_all_my_referrals_modal);
  },
  computed: {
    ...mapState({
      screenWidth: (state) => state.layout.screenWidth,
    }),
    locale() {
      return {
        emptyText: this.labels.allReferralModal.table.emptyText,
      };
    },
    columns() {
      return [
        {
          title: this.labels.allReferralModal.table.columns.ID,
          dataIndex: "id",
          key: "id",
        },
        {
          title: this.labels.allReferralModal.table.columns.commission,
          dataIndex: "commission",
          key: "commission",
          customRender: (text) => {
            return accounting.formatNumber(text || 0, 2, ",", ".");
          },
        },
        {
          title: this.labels.allReferralModal.table.columns.paid,
          dataIndex: "paid",
          key: "paid",
          customRender: (text) => {
            return (
              <a-tag color={text ? "#28a745" : "#6c757d"}>
                {text ? "Si" : "No"}
              </a-tag>
            );
          },
        },
        {
          title: this.labels.allReferralModal.table.columns.date,
          dataIndex: "date",
          key: "date",
          customRender: (text) => {
            return this.$moment(text).format(DATE_FORMAT.MOMENT_DATE_TIME);
          },
        },
      ];
    },
    width() {
      return this.screenWidth < 620 ? "90%" : 800;
    },
  },
  methods: {
    ...mapActions("clientAuth", ["getAllMyReferrals"]),
    handleShowTotal(total, range) {
      return `${range[0]}-${range[1]} de ${total}`;
    },
    close() {
      this.show = false;
    },
    open() {
      this.show = true;
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.all-my-referral-modal {
  &__content {
    padding: 0;
    margin: 0;
    color: var(--text);
    word-break: break-word;
    word-wrap: break-word;
    overflow-wrap: break-word;
    overflow: auto;
    max-height: calc(100vh - 200px);
  }
  .ant-modal-content {
    background-color: var(--modal-bg);
    border: 1px solid var(--modal-shadow);
    box-shadow: 0 1px 3px 3px var(--modal-shadow);
    border-radius: 0;
  }
  .ant-modal-body {
    padding: 24px;
  }
  .ant-modal-header {
    background: var(--modal-bg);
    border-radius: 0;
    .all-my-referral-modal__title {
      color: var(--text) !important;
    }
  }
  .ant-modal-close {
    color: var(--text) !important;
  }
  .ant-table {
    &:hover {
      transition: 0.5s ease;
      background: unset;
    }
    tr.ant-table-row:hover {
      transition: 0.5s ease;
      background: var(--table-hover) !important;
    }
    tr:nth-child(2n) {
      transition: 0.5s ease;
      background: var(--table-striped) !important;
    }
    tr.table-row-disabled,
    tr.table-row-disabled:hover {
      color: var(--table-disabled) !important;
      background: var(--table-disabled) !important;
      font-weight: 600;
    }
    .ant-table-tbody > tr.ant-table-row:hover > td {
      transition: 0.5s ease;
      background: none !important;
    }
    &-tbody,
    &-thead {
      color: var(--text) !important;
      tr {
        th {
          color: var(--text) !important;
          background-color: transparent !important;
        }
      }
    }
    &-footer {
      background: transparent;
    }
    .action-button-view {
      color: var(--btn-text-secoondary);
      border-color: var(--btn-bc-secoondary);
      background-color: var(--btn-bg-secoondary);
      transition: all 0.5s ease;
      &:hover {
        transition: all 0.5s ease;
        color: var(--btn-text-secoondary);
        border-color: var(--btn-bc-secoondary);
        background-color: var(--btn-bg-secoondary);
      }
    }
    .ant-table-placeholder {
      background: var(--card-bg);
      color: var(--text);
      border-radius: 0;
    }
    @media screen and (max-width: $screen-mobile) {
      &-small {
        border: none;
      }
      &-body {
        margin: 0 1px;
      }
    }
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    color: var(--btn-text-secoondary) !important;
    background-color: var(--btn-bg-secoondary) !important;
    border-color: var(--btn-bc-secoondary) !important;
  }
  .ant-pagination-item {
    color: var(--btn-text-secoondary) !important;
    background-color: var(--btn-bg-secoondary) !important;
    border-color: var(--btn-bc-secoondary) !important;
    a {
      color: var(--btn-text-secoondary) !important;
    }
    &-active {
      color: var(--btn-text-primary) !important;
      background-color: var(--btn-bg-primary) !important;
      border-color: var(--btn-bc-primary) !important;
      a {
        color: var(--btn-text-primary) !important;
      }
    }
  }
  .ant-pagination {
    color: var(--text) !important;
  }
}
</style>
